import { Link } from 'react-router-dom';

const ConditionsUtilisation = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <div className="bg-white rounded-lg shadow-sm border p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Conditions d'utilisation</h1>
        
        <div className="space-y-8">
          {/* Introduction */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Introduction</h2>
            <div className="space-y-2 text-gray-700">
              <p>Les présentes conditions d'utilisation régissent l'utilisation de la plateforme EasyRDV, un service de prise de rendez-vous en ligne développé par Yassine Hamdoune.</p>
              <p>En utilisant EasyRDV, vous acceptez d'être lié par ces conditions. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser notre service.</p>
            </div>
          </section>

          {/* Définitions */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Définitions</h2>
            <div className="space-y-2 text-gray-700">
              <p><strong>"Service"</strong> désigne la plateforme EasyRDV accessible via le site web.</p>
              <p><strong>"Utilisateur"</strong> désigne toute personne qui utilise le Service.</p>
              <p><strong>"Compte"</strong> désigne l'espace personnel créé par l'utilisateur pour accéder au Service.</p>
              <p><strong>"Rendez-vous"</strong> désigne une réservation de créneau horaire effectuée via le Service.</p>
            </div>
          </section>

          {/* Description du service */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Description du service</h2>
            <div className="space-y-2 text-gray-700">
              <p>EasyRDV est une plateforme de prise de rendez-vous en ligne qui permet :</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>La création et gestion de comptes utilisateurs</li>
                <li>La prise de rendez-vous en ligne</li>
                <li>La gestion de calendriers et disponibilités</li>
                <li>La notification et rappel de rendez-vous</li>
                <li>L'historique des rendez-vous passés</li>
              </ul>
            </div>
          </section>

          {/* Inscription et compte */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Inscription et compte utilisateur</h2>
            <div className="space-y-2 text-gray-700">
              <p><strong>4.1 Création de compte</strong></p>
              <p>Pour utiliser le Service, vous devez créer un compte en fournissant des informations exactes et à jour.</p>
              
              <p><strong>4.2 Responsabilité du compte</strong></p>
              <p>Vous êtes responsable de :</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>Maintenir la confidentialité de vos identifiants</li>
                <li>Toutes les activités effectuées sous votre compte</li>
                <li>Signaler immédiatement toute utilisation non autorisée</li>
              </ul>
              
              <p><strong>4.3 Informations requises</strong></p>
              <p>Les informations suivantes sont nécessaires : nom, prénom, adresse email, mot de passe sécurisé.</p>
            </div>
          </section>

          {/* Utilisation acceptable */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Utilisation acceptable</h2>
            <div className="space-y-2 text-gray-700">
              <p>Vous vous engagez à utiliser le Service uniquement à des fins légales et appropriées. Il est interdit de :</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>Utiliser le Service à des fins illégales ou frauduleuses</li>
                <li>Tenter de perturber ou compromettre la sécurité du Service</li>
                <li>Utiliser des robots, spiders ou autres moyens automatisés</li>
                <li>Transmettre des virus, vers ou autres éléments nuisibles</li>
                <li>Violer les droits de propriété intellectuelle</li>
                <li>Harceler, menacer ou intimider d'autres utilisateurs</li>
              </ul>
            </div>
          </section>

          {/* Prise de rendez-vous */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Prise de rendez-vous</h2>
            <div className="space-y-2 text-gray-700">
              <p><strong>6.1 Disponibilité</strong></p>
              <p>Les créneaux disponibles sont déterminés par les gestionnaires de la plateforme. Nous nous efforçons de maintenir des créneaux réguliers mais ne garantissons pas la disponibilité permanente.</p>
              
              <p><strong>6.2 Confirmation</strong></p>
              <p>Chaque rendez-vous doit être confirmé par email. Un rendez-vous non confirmé peut être annulé automatiquement.</p>
              
              <p><strong>6.3 Annulation</strong></p>
              <p>Vous pouvez annuler un rendez-vous jusqu'à 24h avant l'heure prévue. Les annulations tardives peuvent être soumises à des restrictions.</p>
            </div>
          </section>

          {/* Propriété intellectuelle */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Propriété intellectuelle</h2>
            <div className="space-y-2 text-gray-700">
              <p>Le Service et son contenu (logiciels, textes, images, logos) sont protégés par les droits de propriété intellectuelle. Tous les droits sont réservés à EasyRDV et Yassine Hamdoune.</p>
              <p>Il est interdit de reproduire, distribuer, modifier ou créer des œuvres dérivées sans autorisation écrite.</p>
            </div>
          </section>

          {/* Confidentialité */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Confidentialité</h2>
            <div className="space-y-2 text-gray-700">
              <p>La protection de vos données personnelles est importante pour nous. Notre politique de confidentialité, disponible sur ce site, décrit comment nous collectons, utilisons et protégeons vos informations.</p>
              <p>En utilisant le Service, vous consentez à la collecte et à l'utilisation de vos informations conformément à notre politique de confidentialité.</p>
            </div>
          </section>

          {/* Limitation de responsabilité */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Limitation de responsabilité</h2>
            <div className="space-y-2 text-gray-700">
              <p>Dans toute la mesure permise par la loi applicable, EasyRDV et Yassine Hamdoune ne seront pas responsables :</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>Des dommages indirects, accessoires ou consécutifs</li>
                <li>Des pertes de données ou interruptions de service</li>
                <li>Des actions des utilisateurs tiers</li>
                <li>Des problèmes techniques indépendants de notre volonté</li>
              </ul>
              <p>Notre responsabilité totale est limitée au montant payé pour l'utilisation du Service dans les 12 mois précédant le dommage.</p>
            </div>
          </section>

          {/* Disponibilité du service */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Disponibilité du service</h2>
            <div className="space-y-2 text-gray-700">
              <p>Nous nous efforçons de maintenir le Service disponible 24h/24 et 7j/7, mais nous ne garantissons pas une disponibilité ininterrompue. Le Service peut être temporairement indisponible pour maintenance, mises à jour ou raisons techniques.</p>
              <p>Nous nous réservons le droit de suspendre ou d'interrompre le Service à tout moment, avec ou sans préavis.</p>
            </div>
          </section>

          {/* Résiliation */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Résiliation</h2>
            <div className="space-y-2 text-gray-700">
              <p><strong>11.1 Résiliation par l'utilisateur</strong></p>
              <p>Vous pouvez résilier votre compte à tout moment en nous contactant ou en supprimant votre compte depuis les paramètres.</p>
              
              <p><strong>11.2 Résiliation par EasyRDV</strong></p>
              <p>Nous pouvons suspendre ou résilier votre compte en cas de violation de ces conditions, avec ou sans préavis.</p>
              
              <p><strong>11.3 Effets de la résiliation</strong></p>
              <p>À la résiliation, votre accès au Service sera immédiatement suspendu et vos données pourront être supprimées conformément à notre politique de confidentialité.</p>
            </div>
          </section>

          {/* Modifications */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Modifications des conditions</h2>
            <div className="space-y-2 text-gray-700">
              <p>Nous nous réservons le droit de modifier ces conditions à tout moment. Les modifications seront publiées sur cette page avec une date de mise à jour.</p>
              <p>Votre utilisation continue du Service après publication des modifications constitue votre acceptation des nouvelles conditions.</p>
            </div>
          </section>

          {/* Droit applicable */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">13. Droit applicable et juridiction</h2>
            <div className="space-y-2 text-gray-700">
              <p>Ces conditions sont régies par le droit français. Tout litige sera soumis à la compétence exclusive des tribunaux français.</p>
              <p>Si une disposition de ces conditions est jugée invalide, les autres dispositions restent en vigueur.</p>
            </div>
          </section>

          {/* Contact */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">14. Contact</h2>
            <div className="space-y-2 text-gray-700">
              <p>Pour toute question concernant ces conditions d'utilisation, contactez-nous :</p>
              <p><strong>Email :</strong> hamdouneyassine.03@gmail.com</p>
              <p><strong>Développeur :</strong> Yassine Hamdoune</p>
            </div>
          </section>

          {/* Dernière mise à jour */}
          <section className="bg-gray-50 p-4 rounded-lg">
            <p className="text-sm text-gray-600">
              <strong>Dernière mise à jour :</strong> 05/07/2025
            </p>
          </section>
        </div>

        {/* Back to home */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <Link 
            to="/" 
            className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium"
          >
            ← Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ConditionsUtilisation; 